import {
  Button,
  ButtonProps,
  Stack,
  StackProps,
  Typography,
  TypographyProps,
} from '@mui/material';
import React from 'react';
import { TP_COLORS } from '../../../constants';

const stackStyles: StackProps['sx'] = {
  minHeight: { xs: '84px', sm: '50px' },
  alignItems: 'center',
  flexDirection: { xs: 'column', sm: 'row' },
  justifyContent: { xs: 'space-evenly', sm: 'center' },
  position: 'sticky',
  top: { xs: '56px', sm: '64px' },
  zIndex: 5,
  backgroundColor: TP_COLORS.blue.dark,
};

const typoProps: TypographyProps = {
  variant: 'subtitle1',
  color: TP_COLORS.white,
  textAlign: 'center',
  margin: { xs: '8px 8px 0px 8px', sm: '10px' },
};

const buttonProps: ButtonProps = {
  color: 'inherit',
  variant: 'text',
  sx: {
    textDecoration: 'underline',
    color: TP_COLORS.white,
    fontSize: '16px',
    minWidth: '110px',
    fontWeight: '600',
  },
};

const TopBanner: React.FC = () => {
  const redirectLink =
    'https://www.tutopiya.com/learning-portal/dashboard/cambridge-igcse/biology/human-nutrition/mini-learning-course/667a7a84e5f66578734dbe74';

  return (
    <Stack sx={stackStyles}>
      <Typography {...typoProps}>
        Exciting News! Check out our new Mini Learning Course, designed to help
        you master key concepts with ease!
      </Typography>
      <Button {...buttonProps} href={redirectLink}>
        Check Now
      </Button>
    </Stack>
  );
};

export default TopBanner;
